const doc = [({"en":({"js":({"admin":({"tenant_photo_products":({"create_card":({"choose_photo_product":"Choose photo product"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;